module.exports = __webpack_public_path__ + "/static/images/cbi_logo.35bd053aed7d83000b6dc7770401edb6.png";


//////////////////
// WEBPACK FOOTER
// ./images/cbi_logo.png
// module id = Ijft
// module chunks = 0